import * as React from 'react';
import { getAgendaMeetingActivities } from '../../../api/activityClientApi';
import { appUrlBuilder } from '../../../utils/appUrlBuilder';
import { DashboardCard } from './DashboardCard';
import { DashboardCardContent } from './DashboardCardContent';

export function DashboardMeetingCard(): JSX.Element {
    
    const [meetings, setMeetings] = React.useState([]);
    const [status, setStatus] = React.useState("");

    React.useEffect(()=>{
        const getData = async () => {
            const activities = await getAgendaMeetingActivities("WorkgroupMeeting");
            const now = new Date();
            // Only keep future meetings
            const activitiesPresent = activities
                .filter(a => new Date(a.start) <= now && new Date(a.end) >= now)
                .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
            
            const futureActivities = activities
                .filter(a => a.start && new Date(a.start) > now)
                .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());

            if(activitiesPresent.length > 0){
                setStatus("present");
                setMeetings(activitiesPresent);
            } else {
                setStatus("future");
                setMeetings(futureActivities);
            }
        };
        getData();  

    },[])

    return (
        <DashboardCard backgroundIcon="calendar" backgroundColor="white">
            {meetings.length > 0 ? (
                <DashboardCardContent 
                    title="AMO møde"
                    activityStatus={status === "present" ? `Nuværende AMO møde ${meetings[0].start.toLocaleDateString()} - ${meetings[0].end.toLocaleDateString()}` : `Kommende AMO møde ${meetings[0].start.toLocaleDateString()} - ${meetings[0].end.toLocaleDateString()}`}
                    activityLink={appUrlBuilder.annualWorkGroupStatus.internal(meetings[0].id)}
                    activityTitle={meetings[0].title}
                />
            ) : (
                <DashboardCardContent 
                    title="AMO møde"
                    activityStatus="Ingen kommende AMO møder"
                    activityLink={appUrlBuilder.annualWorkGroupStatus.list()}
                    activityTitle="Opret et AMO møde"
                    createNew={true}
                />
            )}
    </DashboardCard>
    );
}